import apiConfig from "../configs/api-config";
import apiUtil from "../utils/api-util";
// 1-问卷调查，2-联系我们
var submitMsg = (data, successCallback, failCallback) => {
    apiUtil.config(apiConfig.user.submitMsg).request({
        data: data
    }).then(result => {
        if(result.error_code == apiConfig.errorCode.success) {
            successCallback(result.data);
        } else {
            failCallback(result.error_code, result.errorMsg);
        }
    });
}
export default {
    submitMsg
}


// WEBPACK FOOTER //
// ./src/models/user-model.js